var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AUserContentDisplay"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"UserContent"},[_c('div',{class:{'is-inline-block': _vm.inline},style:([_vm.minWidth ? {'minWidth': _vm.minWidth} : null]),domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }